export default __webpack_public_path__ + "static/media/Reader's Robes of the Heavens.b46b1118.jpg";